import { ClientColumn, ClientView } from "@common/types/views/clientViews";
import { NamedView, ViewType } from "@common/types/views/views";
import { useTypedFlags } from "@hooks/useTypedFlags";

export const useDefaultClientView = (): NamedView<ClientView> => {
    const { clientBulkSelection } = useTypedFlags();

    return {
        id: "default",
        name: "All Clients",
        type: ViewType.CLIENT,
        options: {
            selection: true,
            bulkActions: clientBulkSelection,
        },
        columns: [
            {
                id: ClientColumn.NAME,
                options: {
                    pin: "left",
                },
            },
            {
                id: ClientColumn.ENTITIES,
            },
            {
                id: ClientColumn.PLAN,
            },
            {
                id: ClientColumn.BILLING_OWNERSHIP,
            },
            {
                id: ClientColumn.TEAM,
            },
            {
                id: ClientColumn.START_DATE,
            },
            {
                id: ClientColumn.ACTIONS,
                options: {
                    pin: "right",
                },
            },
        ],
        filters: {},
    };
};
